<div class="wizard-step-content">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h3 class="mb-1">
        <i class="fa fa-concierge-bell text-primary me-2"></i>
        {{ 'eventWizard.services.title' | translate }}
      </h3>
      <p class="text-muted mb-0">{{ 'eventWizard.services.subtitle' | translate }}</p>
    </div>
    <app-button
      [variant]="'primary'"
      [label]="'eventWizard.services.addService' | translate"
      [iconClass]="'fa fa-plus'"
      [disabled]="!event"
      (clicked)="openAddServiceModal()"
    />
  </div>

  @if (!event) {
    <div class="alert alert-warning">
      <i class="fa fa-exclamation-triangle me-2"></i>
      {{ 'eventWizard.services.completeBasicFirst' | translate }}
    </div>
  } @else if (services.length === 0) {
    <div class="text-center py-10">
      <i class="fa fa-concierge-bell fs-3x text-muted mb-4 d-block opacity-50"></i>
      <h5 class="text-muted mb-2">{{ 'eventWizard.services.noServicesYet' | translate }}</h5>
      <p class="text-muted mb-4">{{ 'eventWizard.services.servicesOptional' | translate }}</p>
    </div>
  } @else {
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
        <thead class="fs-7 text-gray-500 text-uppercase">
          <tr>
            <th class="min-w-200px">{{ 'eventWizard.services.name' | translate }}</th>
            <th class="min-w-200px">{{ 'eventWizard.services.description' | translate }}</th>
            <th class="min-w-100px">{{ 'eventWizard.services.price' | translate }}</th>
            <th class="min-w-100px">{{ 'eventWizard.services.maxRegistrations' | translate }}</th>
            <th class="text-end min-w-100px">{{ 'common.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody class="fs-6">
          @for (service of services; track service.event_service_id) {
            <tr>
              <td>
                <span class="fw-semibold text-gray-800">{{ service.event_service_name }}</span>
              </td>
              <td class="text-muted">{{ service.event_service_description || '-' }}</td>
              <td>{{ service.price || 0 }} {{ event?.default_currency || service.price_currency || 'NOK' }}</td>
              <td>{{ service.max_num_registrations || ('eventWizard.services.unlimited' | translate) }}</td>
              <td class="text-end">
                <div class="d-flex justify-content-end gap-2">
                  <button
                    class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                    (click)="openEditServiceModal(service)"
                    [title]="'common.edit' | translate"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-icon btn-light btn-active-light-danger"
                    (click)="deleteService(service)"
                    [title]="'common.delete' | translate"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="alert alert-light-info border border-info border-dashed mt-4">
      <div class="d-flex align-items-center">
        <i class="fa fa-info-circle text-info fs-2 me-3"></i>
        <div>
          <strong>{{ 'eventWizard.services.servicesAdded' | translate:{ count: services.length } }}</strong>
          <div class="text-muted">{{ 'eventWizard.services.continueOrAddMore' | translate }}</div>
        </div>
      </div>
    </div>
  }
</div>
